export default {
  add_news: "Add News",
  edit_news: "Edit News",
  detail_news: "Detail News",
  search_news: "Search News",
  my_news: "My News"
};
